import React from 'react'

export const RempeHeader = ({ title = 'Titulo', children, text = '', total = 0 }) => {
  return (
    <div className="rempe_status">
      <h4 style={{ color: 'black' }}>
        {title}
        {!!total && (
          <span style={{ fontWeight: 400, fontSize: 14, padding: 10 }}>
            ( {total} {text} )
          </span>
        )}
      </h4>

      <span style={{ display: 'flex', alignItems: 'center' }}>{children}</span>
    </div>
  )
}
